import React from 'react';



export default function BuyerMapEd() {

  return (
    <>
        <h1> THE BUYER UTILITY MAP </h1>
        <p>The Buyer Utility Map is a tool which outlines the full range of experiences buyers have in using your industry’s offering. It reveals the problems the industry has failed to address, creating pain points worth solving.</p>
        <img src={`${process.env.PUBLIC_URL}/images/2. bayer-com.jpg`} style={{width: 600}}/>
        <h3>
          Key elements of the Buyer Utility Map:
        </h3>
        <p>
          1. The rows contain The Six Stages of the Buyer Experience Cycle: Purchase, Delivery, Use, Supplements, Maintenance, Disposal. Each industry may have its own Stages of the Buyer Experience Cycle.
        </p>

        <p>
          2. The columns display The Six Buyer Utility Levers. It is the major levers organizations can use to provide greater utility for buyers. The crossing of The Six Stages of the Buyer Experience Cycle and The Six Stages of the Buyer Experience Cycle gives 36 possible options (niche utilities).
        </p>

        <p>
          3. You can exchange rows and columns in case it will be more convenient for reading and working with the tool.

          The main aim of this tool is to determine which of the consumer’s problems has not been solved yet by your industry. Doing this, you reveal hidden opportunities for exiting the competitive environment and increasing the size of the market.
        </p>

        <h3>
          How to work with the instrument:
        </h3>

        <p>
          1. Using The Stages of the Buyer Experience Cycle describes the experience you consumers get while interacting with your product.
        </p>
        <p>
          2. Describe a variety of specific experiences each stage encompasses.
        </p>
        <p>
          3. Explore The Six Utility Levers. Moving from one stage of the Buyer Experience Cycle to another determine the consumer’s pain points.
        </p>
        <p>
          4. Fill out The Buyer Utility Map by placing pain points and describing the reasons of their existence. Identify the utility niche that the industry is currently focusing on.
        </p>

        <h3>
          Rules:
        </h3>

        <p>
          1. To determine the pain points at the crossing of all stages of the Buyer Experience Cycle and the Six Utility Levers answer two questions: «What is the biggest block to utility lever in each stage?» and «What are the key reasons for this block?».
        </p>
        <p>
          2. For a clear understanding the meaning of each utility lever read a brief summary:
        </p>
          <p>
            Productivity: Anything to do with efficiency – less time, effort, and/or money – in fulfilling the buyer’s needs..
          </p>

          <p/>
            Simplicity: Anything that eliminates or minimizes complexity or mental issues.

          <p/>
            Convenience: When and where I want something – like 24/7, 365
          <p/>
            Risk Reduction: This may be financial, physical and emotional, including reputation.
          <p/>
            Fun and Image: This is the tangible and intangible aesthetic look, feel, attitude and style an offering conveys.
          <p/>
            Environmental Friendliness: This lever is related to environmental issues: environmentally friendly offering, the organization’s strong reputation for environmental friendliness

    </>
  )
}
